import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentFail = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 300 300",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 198.02,
			cy: 107.02,
			r: 95.11,
			fill: "var(--primary)",
			fillOpacity: .16
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 245.61,
			height: 169.6,
			x: 20.78,
			y: 71.71,
			fill: "var(--foreground)",
			rx: 18.44,
			ry: 18.44,
			transform: "rotate(13.14 143.58 156.5)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 226.03,
			height: 156.08,
			x: 33.23,
			y: 78.1,
			fill: "var(--foreground)",
			rx: 16.97,
			ry: 16.97,
			transform: "rotate(-8 146.25 156.14)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M59.6 248.57c-4.01 0-7.89-1.3-11.15-3.75a18.5 18.5 0 0 1-7.21-12.25l-17-120.96c-.7-4.91.57-9.8 3.56-13.77a18.5 18.5 0 0 1 12.25-7.21l190.23-26.74c4.91-.7 9.8.58 13.76 3.56a18.5 18.5 0 0 1 7.22 12.26l17 120.95a18.6 18.6 0 0 1-15.81 20.99L62.22 248.38q-1.32.19-2.62.19M232.9 66.93q-1.08 0-2.17.16L40.5 93.82c-4.06.57-7.66 2.69-10.13 5.97s-3.51 7.31-2.94 11.37l17 120.96a15.3 15.3 0 0 0 5.96 10.13 15.3 15.3 0 0 0 11.38 2.94L252 218.45a15.37 15.37 0 0 0 13.07-17.34l-17-120.96a15.3 15.3 0 0 0-5.97-10.12 15.2 15.2 0 0 0-9.2-3.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "m244.33 80.68 17 120.95a16.96 16.96 0 0 1-14.43 19.17L56.67 247.53A16.97 16.97 0 0 1 37.5 233.1l-17-120.95a16.97 16.97 0 0 1 14.44-19.17l89.12-12.52-12.61 18.69 23.32 2.57-21.73 18.9 17.9 12.4-5.46 37.18 23.25-39.78-18.55-10.03 27.53-24.6-24.84-4.54 20.24-14.87 72.07-10.13a16.96 16.96 0 0 1 19.15 14.44Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M54.3 249.31a18.6 18.6 0 0 1-18.4-16l-17-120.94a18.6 18.6 0 0 1 15.82-21l89.11-12.52a1.61 1.61 0 0 1 1.56 2.5l-11.12 16.48 20.68 2.29a1.61 1.61 0 0 1 .88 2.81l-20.17 17.54 16.2 11.22c.5.35.76.95.68 1.56l-4.26 28.96 18.22-31.17-17.1-9.24a1.6 1.6 0 0 1-.3-2.62l25.08-22.41-21.6-3.94a1.61 1.61 0 0 1-.67-2.89l20.25-14.87q.32-.24.73-.3l72.06-10.13a18.6 18.6 0 0 1 20.98 15.82l17 120.95a18.5 18.5 0 0 1-3.56 13.77 18.5 18.5 0 0 1-12.25 7.22L56.9 249.13q-1.3.2-2.6.19Zm66.4-166.76L35.17 94.57a15.4 15.4 0 0 0-13.07 17.35l17 120.95a15.4 15.4 0 0 0 17.34 13.07l190.23-26.73a15.33 15.33 0 0 0 13.06-17.35l-17-120.95a15.4 15.4 0 0 0-17.33-13.08l-71.66 10.08-16.9 12.42L158 94.19a1.61 1.61 0 0 1 .78 2.79l-25.82 23.07L149.5 129a1.6 1.6 0 0 1 .63 2.23l-23.25 39.79a1.61 1.61 0 0 1-3-1.05l5.32-36.2-17.08-11.82a1.6 1.6 0 0 1-.14-2.54l18.96-16.49-19.67-2.17a1.6 1.6 0 0 1-1.16-2.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m72.19 115.16 18.26-2.57-.24-1.75a7.5 7.5 0 0 0-8.46-6.38L70.9 106zm1.04 7.38 18.27-2.57 1.82 12.98-18.27 2.57zm-6.11 10.13-18.27 2.57 1.53 10.85a7.5 7.5 0 0 0 8.46 6.37l10.85-1.52zm-1.04-7.38-2.57-18.27-10.84 1.53a7.5 7.5 0 0 0-6.38 8.46l1.52 10.85zm10 17.62.99 7 10.85-1.53a7.47 7.47 0 0 0 6.39-8.03zm-16.77 55.22a2.55 2.55 0 0 1-.35-5.06l24.31-3.42a2.55 2.55 0 0 1 .71 5.04l-24.3 3.42q-.2.03-.37.02m37.63-5.28a2.55 2.55 0 0 1-.35-5.07l24.3-3.42a2.55 2.55 0 0 1 .72 5.05l-24.32 3.41zm37.62-5.29a2.55 2.55 0 0 1-.35-5.07l24.3-3.41a2.55 2.55 0 0 1 .72 5.04l-24.31 3.42zm33.53-88.9a2.55 2.55 0 0 1-.35-5.07l54.42-7.65a2.55 2.55 0 0 1 .7 5.04l-54.4 7.65zm2.72 19.34a2.55 2.55 0 0 1-.35-5.07l27.2-3.83a2.55 2.55 0 0 1 .72 5.05l-27.21 3.82zm1.37 64.27a2.55 2.55 0 0 1-.35-5.07l24.31-3.41a2.55 2.55 0 1 1 .7 5.04l-24.3 3.42zM209.8 177a2.55 2.55 0 0 1-.35-5.07l24.31-3.42a2.55 2.55 0 0 1 .71 5.04l-24.31 3.42z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 208.01,
			cy: 203.68,
			r: 12.28,
			fill: "var(--foreground)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M235.2 199.86a12.27 12.27 0 0 1-15.09 13.64 15.54 15.54 0 0 0-3.16-22.59 12.27 12.27 0 0 1 18.25 8.94Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 137.17,
			cy: 234.4,
			r: 56.38,
			fill: "var(--foreground)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M137.17 292.2c-31.87 0-57.8-25.93-57.8-57.8s25.93-57.8 57.8-57.8 57.8 25.93 57.8 57.8-25.93 57.8-57.8 57.8m0-112.77c-30.31 0-54.97 24.66-54.97 54.97s24.66 54.97 54.97 54.97 54.97-24.66 54.97-54.97-24.66-54.97-54.97-54.97"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 131.95,
			cy: 234.4,
			r: 56.38,
			fill: "var(--card)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M131.95 292.2c-31.87 0-57.8-25.93-57.8-57.8s25.94-57.8 57.8-57.8 57.8 25.93 57.8 57.8-25.93 57.8-57.8 57.8m0-112.77c-30.3 0-54.97 24.66-54.97 54.97s24.66 54.97 54.97 54.97 54.98-24.66 54.98-54.97-24.66-54.97-54.98-54.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m99.4 252.85 51.62-50.65 13.5 13.76-51.62 50.64z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m99.76 215.34 13.76-13.5 50.63 51.63-13.75 13.49z"
		})
	]
});
export default SvgPaymentFail;
